import { Container } from '@xo-union/tk-component-grid';
import { H4 } from '@xo-union/tk-ui-typography';
import React, { ReactNode } from 'react';

import styles from './rightRailSection.scss';

interface Props {
  name: string;
  children: ReactNode;
  inlineChild?: ReactNode;
}

const RightRailSection: React.FC<Props> = ({ name, inlineChild, children }) => (
  <div className={styles.container}>
    <div className={styles.titleContainer}>
      <H4 className={styles.title} as="h2">
        {name}
      </H4>
      {inlineChild && <div>{inlineChild}</div>}
    </div>
    <Container>{children}</Container>
  </div>
);

export default RightRailSection;
